<script>
    import LayoutGrid, {Cell as LayoutCell} from "@smui/layout-grid";
    import DataTable, {Head, Body, Row, Cell} from '@smui/data-table';
    import Paper, {Title, Subtitle, Content} from '@smui/paper';

    import SalaryHeadRight from "../calculate/SalaryHeadRight.svelte";
    import SalaryHeadLeft from "./SalaryHeadLeft.svelte";
    import SalaryFooterOne from "./SalaryFooterOne.svelte";
    import SalaryFooterThree from "./SalaryFooterThree.svelte";
    import Percent from "./Percent.svelte";
    import Currency from "./Currency.svelte";

    let targetElement;

    /** @type (array) result array from API */
    export let result = undefined;

    function getValue(result, key, period = "monthly") {
        let periodFactor = period === "yearly" && key !== "dailyRate" ? 12 : 1;
        return result[key] * periodFactor;
    }

    const sortedRubrics = Object.entries(result.rawData.rubrics)
        .sort(([keyA, rubricA], [keyB, rubricB]) => rubricA.code.localeCompare(rubricB.code));

</script>
<LayoutGrid style="padding: 0" id="id-print-salary" bind:this={targetElement}>
    <LayoutCell span={12}>
        <Paper variant="outlined" style="padding: 10px 10px">
            <LayoutGrid style="padding: 0;">
                <SalaryHeadLeft span={4} cssClass="no-web"/>
                <SalaryHeadRight {result} span={4} cssClass="no-web"/>
                <SalaryHeadLeft span={6} cssClass="resume-salary"/>
                <SalaryHeadRight {result} span={6} cssClass="resume-salary"/>
                <SalaryHeadLeft span={6} cssClass="download"/>
                <SalaryHeadRight {result} span={6} cssClass="download"/>
            </LayoutGrid>
        </Paper>
    </LayoutCell>

    <LayoutCell span={12}>
        <DataTable table$aria-label="salary-one" style="width: 100%;">
            <Head>
                <Row style="height: 25px;">
                    <Cell as="th" colspan="3"
                          style="background-color:#0000A0;border-color:#0000A0;border-radius:0;color:white;"></Cell>
                    <Cell as="th" colspan="2"
                          style="background-color:#0000A0;border-color:#0000A0;border-radius:0;color:white;">Part
                        salariale
                    </Cell>
                    <Cell as="th" colspan="2"
                          style="background-color:#0000A0;border-color:#0000A0;border-radius:0;color:white;">Part
                        patronale
                    </Cell>
                </Row>
                <Row style="height: 25px;">
                    <Cell style="background-color:#0000A0;color:white;border-color:#0000A0;border-radius:0;">
                        Désignation
                    </Cell>
                    <Cell style="background-color:#0000A0;color:white;border-color:#0000A0;border-radius:0;">Nombre
                    </Cell>
                    <Cell style="background-color:#0000A0;color:white;border-color:#0000A0;border-radius:0;text-align: right;">
                        Base
                    </Cell>
                    <Cell style="background-color:#0000A0;color:white;border-color:#0000A0;border-radius:0;text-align: right;">
                        Taux
                    </Cell>
                    <Cell style="background-color:#0000A0;color:white;border-color:#0000A0;border-radius:0;text-align: right;">
                        Retenu
                    </Cell>
                    <Cell style="background-color:#0000A0;color:white;border-color:#0000A0;border-radius:0;text-align: right;">
                        Taux
                    </Cell>
                    <Cell style="background-color:#0000A0;color:white;border-color:#0000A0;border-radius:0;text-align: right;">
                        Retenu
                    </Cell>
                </Row>
            </Head>
            <Body>
            <!--
            <Row>
                <Cell>Plafond sécurité sociale</Cell>
                <Cell numeric><Number number={result.rawData.constants.monthlySocialSecurityCeiling.amount} /></Cell>
                <Cell></Cell>
                <Cell></Cell>
                <Cell></Cell>
                <Cell></Cell>
                <Cell></Cell>
                <Cell></Cell>
            </Row>
            <Row>
                <Cell>Total Brut de Base</Cell>
                <Cell numeric><Number number={result.totalBaseGross} /></Cell>
                <Cell></Cell>
                <Cell></Cell>
                <Cell></Cell>
                <Cell></Cell>
                <Cell></Cell>
                <Cell></Cell>
            </Row>
            -->
            {#each sortedRubrics as [key, rubric]}
                {#if rubric.salary.rate || rubric.employer.rate}
                    <Row style="height: 20px;">
                        <Cell class="border-right">{rubric.designation}</Cell>
                        <Cell class="border-right">{rubric.code}</Cell>
                        <Cell class="border-right" style="text-align: right;">
                            <Currency number={rubric.base} noZero={true}/>
                        </Cell>
                        <Cell class="border-right" style="text-align: right;">
                            <Percent number={rubric.salary.rate} noZero={true}/>
                        </Cell>
                        <Cell class="border-right" style="text-align: right;">
                            <Currency number={rubric.salary.deduction} noZero={true}/>
                        </Cell>
                        <Cell class="border-right" style="text-align: right;">
                            <Percent number={rubric.employer.rate} noZero={true}/>
                        </Cell>
                        <Cell style="text-align: right;">
                            <Currency number={rubric.employer.deduction} noZero={true}/>
                        </Cell>
                    </Row>
                {/if}
            {/each}
            <Row style="height: 20px;">
                <Cell class="border-right" style="font-weight: bold;">Total Cotisations</Cell>
                <Cell class="border-right"></Cell>
                <Cell class="border-right"></Cell>
                <Cell class="border-right"></Cell>
                <Cell class="border-right" style="text-align: right;font-weight: bold;">
                    <Currency number={result.totalSalaryContributions}/>
                </Cell>
                <Cell class="border-right"></Cell>
                <Cell class="border-right" style="text-align: right;font-weight: bold;">
                    <Currency number={result.totalEmployerContributions}/>
                </Cell>
            </Row>
            <Row style="height: 20px;">
                <Cell class="border-right">Rémunération Nette Fiscale</Cell>
                <Cell class="border-right"></Cell>
                <Cell class="border-right" style="text-align: right;">
                    <Currency number={result.taxableNetSalary}/>
                </Cell>
                <Cell class="border-right"></Cell>
                <Cell class="border-right"></Cell>
                <Cell class="border-right"></Cell>
                <Cell class="border-right"></Cell>
            </Row>
            <Row style="height: 20px;">
                <Cell class="border-right">Montant net social</Cell>
                <Cell class="border-right"></Cell>
                <Cell class="border-right" style="text-align: right;">
                    <Currency number={result.netSalary}/>
                </Cell>
                <Cell class="border-right"></Cell>
                <Cell class="border-right"></Cell>
                <Cell class="border-right"></Cell>
                <Cell class="border-right"></Cell>
            </Row>
            </Body>
        </DataTable>
    </LayoutCell>
    <SalaryFooterOne {result} span="6" cssClass="download"/>
    <SalaryFooterThree {result} span="6" cssClass="download"/>
    <SalaryFooterOne {result} span="6" cssClass="resume-salary"/>
    <SalaryFooterThree {result} span="6" cssClass="resume-salary"/>
    <SalaryFooterOne {result} span="4" cssClass="no-web"/>
    <SalaryFooterThree {result} span="4" cssClass="no-web"/>
</LayoutGrid>
<style>
    @media print {
        /* Réinitialisation des marges du document */
        html, body {
            margin: 0;
            padding: 0;
        }
    }

    :global(.border-right) {
        border-right-width: 1px;
        border-right-style: solid;
        border-right-color: rgba(0, 0, 0, .12);
    }

    :global(.border-right-white) {
        border-right-width: 1px;
        border-right-style: solid;
        border-right-color: white;
    }

    :global(.border-left) {
        border-left-width: 1px;
        border-left-style: solid;
        border-left-color: rgba(0, 0, 0, .12);
    }
</style>
